import { Card, Divider, PageContainer, Skeleton, Surface } from "@/components/ui";

/** Loading placeholder of the item detail: photo band, title block and two option groups. */
export function ItemDetailSkeleton() {
  return (
    <div aria-busy className="mx-auto max-w-shell pb-20">
      <Skeleton shape="flat" className="h-36 w-full md:h-64" />

      <Surface surface="card">
        <Divider />
        <PageContainer surface="card">
          <div className="-mt-14 flex justify-end">
            <Skeleton shape="block" className="h-20 w-36" />
          </div>

          <div className="mb-2 mt-4 flex flex-col gap-3">
            <Skeleton shape="block" className="h-7 w-3/5" />
            <div className="flex flex-col gap-2">
              <Skeleton className="w-full" />
              <Skeleton className="w-4/5" />
            </div>
          </div>

          <div className="mt-6 flex flex-col gap-4">
            {[1, 2].map((group) => (
              <Card key={group} variant="outline">
                <Skeleton className="mb-3 h-5 w-2/5" />
                <div className="flex flex-col gap-2">
                  <Skeleton shape="block" className="h-10 w-full" />
                  <Skeleton shape="block" className="h-10 w-full" />
                </div>
              </Card>
            ))}
          </div>
        </PageContainer>
      </Surface>
    </div>
  );
}
